module.exports = __webpack_public_path__ + "static/images/finance-1.bf75c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-1.png
// module id = HmPm
// module chunks = 8